import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WatcherService } from 'src/app/services/watcher.service';

@Component({
  selector: 'app-shop-walmart-us',
  templateUrl: './shop-walmart-us.component.html',
  styleUrls: ['./shop-walmart-us.component.css'],
})
export class ShopWalmartUsComponent implements OnInit, OnDestroy {
  lang: string = 'en';
  constructor(private watcherService: WatcherService, private router: Router) {}

  createWalmartSchema() {
    // Schema for Walmart
    if (!document.getElementById('shopWalmartUsSchema')) {
      const walmartSchema = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "headline": "How to Shop Walmart and Ship Internationally",
        "description": "Learn how to shop on Walmart and manage international shipping effectively. Find detailed instructions on navigating Walmart's platform, selecting products for global delivery, and ensuring your purchases reach you wherever you are.",
        "url": `https://www.shippn.com//stores/how-to-shop-walmart-and-ship-internationally`,
        "author": [{
          "@type": "Person",
          "name": "Shippn Team",
          "url": `https://www.shippn.com//about`
        }]
      };
      const scriptEl = document.createElement('script');
      scriptEl.type = 'application/ld+json';
      scriptEl.innerHTML = JSON.stringify(walmartSchema);
      scriptEl.id = 'shopWalmartUsSchema';
      document.head.appendChild(scriptEl);
    }
  
    // Breadcrumb Schema
    if (!document.getElementById('shopWalmartUsBreadcrumbSchema')) {
      const breadcrumbSchema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "item": {
              "@id": `https://www.shippn.com//home`,
              "name": "Home"
            }
          },
          {
            "@type": "ListItem",
            "position": 2,
            "item": {
              "@id": `https://www.shippn.com//stores`,
              "name": "Best Global Stores for International Shipping"
            }
          },
          {
            "@type": "ListItem",
            "position": 3,
            "item": {
              "@id": `https://www.shippn.com//stores/how-to-shop-walmart-and-ship-internationally`,
              "name": "How To Shop Walmart and Ship Internationally"
            }
          }
        ]
      };
      const scriptEl = document.createElement('script');
      scriptEl.type = 'application/ld+json';
      scriptEl.innerHTML = JSON.stringify(breadcrumbSchema);
      scriptEl.id = 'shopWalmartUsBreadcrumbSchema';
      document.head.appendChild(scriptEl);
    }
  
    // Article Schema
    if (!document.getElementById('shopWalmartUsArticleSchema')) {
      const articleSchema = {
        "@context": "https://schema.org",
        "@type": "Article",
        "headline": "How to Shop Walmart and Ship Internationally",
        "image": [
          "https://www.shippn.com/assets/img/stores/walmart/walmart_logo.webp",
          "https://www.shippn.com/assets/img/stores/walmart/walmart-step-1.webp",
          "https://www.shippn.com/assets/img/stores/walmart/walmart-step-2.webp",
          "https://www.shippn.com/assets/img/stores/walmart/walmart-step-3.webp"
        ],
        "datePublished": "2024-08-29T14:31:13.976Z",
        "dateModified": "2024-08-29T14:31:13.976Z",
        "author": [{
          "@type": "Person",
          "name": "Shippn Team",
          "url": `https://www.shippn.com//about`
        }],
        "url": `https://www.shippn.com//stores/how-to-shop-walmart-and-ship-internationally`
      };
      const scriptEl = document.createElement('script');
      scriptEl.type = 'application/ld+json';
      scriptEl.innerHTML = JSON.stringify(articleSchema);
      scriptEl.id = 'shopWalmartUsArticleSchema';
      document.head.appendChild(scriptEl);
    }
  }

  ngOnInit(): void {
    this.watcherService.getLang().subscribe((lang) => {
      this.lang = lang;
      this.createWalmartSchema();
    });
  }

  goToSignIn() {
    this.router.navigate(['/','signin']);
  }

  ngOnDestroy(): void {
    const schemas = ['shopWalmartUsSchema', 'shopWalmartUsBreadcrumbSchema', 'shopWalmartUsArticleSchema'];
    
    schemas.forEach(schemaId => {
      const schemaElement = document.getElementById(schemaId);
      if (schemaElement) {
        document.head.removeChild(schemaElement);
      }
    });
  }
}
